import Inicio from "./pages/Inicio/Inicio";

const routes = [
  {
    key: "inicio", // Clave única
    name: "INICIO",
    route: "/",
    component: <Inicio />,
  }
];

export default routes;
